<script>
  import AnswerFeedback from "./AnswerFeedback.svelte";
  export let closeQuizz;
  export let currentPhotoData;
  import { fly } from "svelte/transition";

  const state = {
    showFeedbackScreen: false,
    hasAnswered: false,
    isAnswerCorrect: null,
  };

  const quizzData = currentPhotoData.quizz;
  // console.log(quizzData);

  const showFeedbackScreen = (iscorrect) => {
    // flash the answer in the correct color!
    state.isAnswerCorrect = iscorrect;
    state.showFeedbackScreen = true;
    window.setTimeout(() => {
      state.showFeedbackScreen = false;
      state.hasAnswered = true;
    }, 1500);
  };
  const hideFeedbackScreen = () => {
    state.showFeedbackScreen = false;
  };
</script>

<div
  class="quizz-container w-100 h-100 bg-custom-yellow absolute top-0 left-0 z-2 pa4 flex flex-column overflow-scroll"
  transition:fly={{
    duration: 250,
    x: window.innerWidth,
    opacity: 0.5,
  }}
>
  {#if state.showFeedbackScreen}
    <AnswerFeedback iscorrect={state.isAnswerCorrect} />
  {/if}
  <div class="flex w-100 items-center mb3">
    <button on:click={closeQuizz} class="back ma0 pa0"
      ><img src="./icones/back.svg" alt="" /></button
    >
    <h2 class="pa0  ma0 ml3">Quizz</h2>
  </div>

  <p class="lh-copy f4 mt0">
    {quizzData.question}
  </p>
  {#if !state.hasAnswered}
    {#each quizzData.answers as { text, is_right }, i}
      <button
        on:click={() => {
          showFeedbackScreen(is_right ? true : false);
        }}
        class="quizz-btn f3 {state.showFeedbackScreen && is_right
          ? 'flash-right'
          : ''}"
        data-correct={is_right ? "true" : "false"}
        style={quizzData.is_image ? "background-color:white!important;" : ""}
      >
        {#if quizzData.is_image}
          <img src={"./logos/" + text} alt={text} />
        {:else}
          {text}
        {/if}
      </button>
    {/each}
  {/if}

  {#if state.hasAnswered}
    {#each quizzData.answers as { text, is_right }, i}
      {#if is_right}
        <button
          class="quizz-btn f3 flash-right"
          data-correct={is_right ? "true" : "false"}
          style={quizzData.is_image ? "background-color:white!important;" : ""}
        >
          {#if quizzData.is_image}
            <img src={"./logos/" + text} alt={text} />
          {:else}
            {text}
          {/if}</button
        >
      {/if}
    {/each}
    <p class="lh-copy f4">
      {quizzData.explanation}
    </p>
  {/if}
</div>

<style>
  .quizz-container {
    position: fixed;
  }

  p {
    height: auto;
  }
  .back {
    background: transparent;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    align-self: flex-end;
  }

  .back img {
    width: 48px;
    height: 48px;
  }

  .quizz-btn {
    padding: 12px;
    margin-bottom: 12px;
    border: 2px solid black;
    background: transparent;
    text-align: left;
    transition: background-color 0.2s ease;
  }

  .quizz-btn:hover,
  .quizz-btn:active,
  .quizz-btn:focus {
    background: #bdbdbd;
  }

  .quizz-btn.correct {
    background-color: #00ffa3;
  }
  .quizz-btn.wrong {
    background-color: #bdbdbd;
  }

  .ok-btn {
    height: 48px;
    min-width: 144px;
  }

  .flash-right {
    background-color: #00ffa3 !important;
  }
</style>
